import React, { useState, useEffect } from 'react';
import {
    User, Mail, Calendar, Clock, MapPin, Users,
    Heart,
    ArrowRight, MessageCircle, Edit2, Trash2, X, Send, Star, Sparkles,
    Music2, Hand, Flame, Cross, AlarmClockCheck, Check, AlertCircle, ActivityIcon,
    XCircle, CheckCircle,
    Phone
} from 'lucide-react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import '../pages/events/inputStyle.css';
import { motion, AnimatePresence, easeInOut, } from 'framer-motion';
import { Toast } from '../components/Toast';
import AdminStystem from './events/emailSender';

function BootCamp() {
    const [form, setForm] = useState({
        first_name: "",
        surname: "",
        email_address: "",
        phone_number: "",
        volunteer: "",
        vip: "false",
        isEmailAvailable: false,
        isPhoneValid: false,
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitted2, setIsSubmitted2] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showWhatsappModal, setShowWhatsappModal] = useState(false);
    const [errors, setErrors] = useState({})

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({})
    };



    const validatePhone_number = (number) => {
        // Remove all non-digit characters
        const cleanNumber = number.replace(/\D/g, "")

        // WhatsApp numbers should be between 10-15 digits
        // Most international numbers are 10-14 digits, but allowing up to 15 for flexibility
        if (cleanNumber.length < 10 || cleanNumber.length > 15) {
            return false
        }

        // Check if it starts with a country code (1-4 digits)
        // Most common patterns: +1, +44, +91, +234, etc.
        const hasValidCountryCode = /^(\+?[1-9]\d{0,3})?[1-9]\d{8,13}$/.test(number.replace(/[\s\-$$$$]/g, ""))

        return hasValidCountryCode
    }

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return emailRegex.test(email)
    }

    const validateForm = () => {
        const newErrors = {}


        if (!form.email_address) {
            newErrors.email_address = "Email is required"
        } else if (!validateEmail(form.email_address)) {
            newErrors.email_address = "Please enter a valid email address"
        }

        if (!form.phone_number) {
            newErrors.phone_number = "WhatsApp number is required"
        } else if (!validatePhone_number(form.phone_number)) {
            newErrors.phone_number = "Please enter a valid WhatsApp number with country code"
        }

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (form.isEmailAvailable === false) {
            Toast.error('Email is already in use. Please use another email.');
            setIsSubmitting(false);
            return;
        }

        if (form.isEmailAvailable === null) {
            Toast.error('Unable to verify email. Please check your connection and try again.');
            setIsSubmitting(false);
            return;
        }

        if (!form.isPhoneValid) {
            Toast.error('Your Phone number is not valid.');
            setIsSubmitting(false);
            return;
        }

        // Proceed to submit
        try {
            const response = await fetch("https://tsoministries.com/wp-json/custom-form/v1/vtc", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const result = await response.json();
            if (response.ok) {
                sendEmail([{ id: 1600, email_address: form.email_address }]);
                setTimeout(() => {
                    Toast.success("Registration successful! We'll be in touch soon.");
                    setIsSubmitting(false);
                    setIsSubmitted(true);
                }, 2000);
                // setForm({
                //     first_name: "",
                //     surname: "",
                //     email_address: "",
                //     phone_number: "",
                //     isEmailAvailable: null,
                //     isPhoneValid: false,
                // });
            } else {
                Toast.success("Something went wrong, Please post this issue in our issues page");
                setTimeout(() => {
                    setIsSubmitting(false);
                    throw new Error(result.message || 'Something went wrong');
                }, 600);
            }
        } catch (error) {
            Toast.error(error.message || 'Failed to submit form');
            setIsSubmitting(false);
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 2000);
        }
    };

    const handle_addWhatsappNumber = async (e) => {
        const newErrors = {}
        e.preventDefault();

        if (!validateForm()) return;

        setIsSubmitting(true);

        try {
            // Step 1: Check if user exists
            const res = await fetch(
                `https://tsoministries.com/wp-json/custom-form/v1/vtc-by-email?email=${encodeURIComponent(form.email_address)}&t=${Date.now()}`
            );

            if (!res.ok) {
                const errorText = await res.text();
                console.error("Failed to check user existence:", res.status, errorText);
                // alert("We couldn't verify your email. Please try again.");
                newErrors.email_address = "We couldn't verify your email. Make sure you are using the same email you registered with.";
                setErrors(newErrors);
                Toast.error("We couldn't verify your email. Please try again. Make sure you are using the same email you registered with.");
                return;
            }


            const data = await res.json();

            if (data?.email_address) {
                // User found — Update
                const updatePayload = {
                    phone_number: form.phone_number,
                    volunteer: "",
                };
                // alert(JSON.stringify(data))

                const updateRes = await fetch(
                    `https://tsoministries.com/wp-json/custom-form/v1/vtc-update/${data.id}`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(updatePayload),
                    }
                );

                if (!updateRes.ok) {
                    const errorBody = await updateRes.text();
                    console.error("Update failed:", updateRes.status, errorBody);
                    Toast.error("Something went wrong. Please try again later.");
                    return;
                }

                // Success
                Toast.success("WhatsApp number added successfully!");
                setShowWhatsappModal(false);
                setIsSubmitted2(true);
                setIsSubmitted(false);
            } else {
                // User not found — Show prompt
                Toast.error("An unexpected error occurred. Please check your internet connection or try again later.");
            }
        } catch (err) {
            console.error("Unexpected error during submission:", err);
            Toast.error("An unexpected error occurred. Please check your internet connection or try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const sendEmail = async (registrants) => {
        for (const registrant of registrants) {
            try {
                const res = await fetch('https://tsoministries.com/wp-json/custom-api/v1/send-vtc-invite', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(registrant),
                });

                if (!res.ok) throw new Error(`Failed to send to ${registrant.email_address}`);
                // setSent(prev => [...prev, registrant]);
            } catch (err) {
                console.error(err);
                // setFailed(prev => [...prev, registrant]);
            }
        }
    };

    // if (isSubmitted) {
    //     return (
    //         <div className="min-h-screen bg-gradient-to-br from-gray-500 via-gray-600 to-yellow-400 flex items-center justify-center p-4">
    //             <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full text-center">
    //                 <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
    //                     <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    //                     </svg>
    //                 </div>
    //                 <h2 className="text-2xl font-bold text-gray-800 mb-4">Registration Successful!</h2>
    //                 <p className="text-gray-600 mb-6">
    //                     Welcome to the TSO Ministries Teens Virtual Boot Camp, {form.name}!
    //                     Check your email for event details and Zoom link.
    //                 </p>
    //                 {/* <button
    //                     onClick={() => setIsSubmitted(false)}
    //                     className="bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-full transition-colors"
    //                 >
    //                     Register Another Person
    //                 </button> */}
    //             </div>
    //         </div>
    //     );
    // }

    return (
        <div className="relative min-h-screen bg-gradient-to-br from-gray-800 via-yellow-800 to-cyan-800 p-4">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(236,72,153,0.8)_0,rgba(236,72,153,0)_70%)] rotate-180 opacity-40"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(236,72,153,0.8)_0,rgba(236,72,153,0)_70%)] rotate-180 opacity-40"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(236,13,68,0.8)_0,rgba(53,72,153,0)_70%)] rotate-0 opacity-60"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(53,13,68,0.8)_0,rgba(53,13,68,0)_70%)] rotate-180 opacity-60"></div>
            <div className='absolute h-full w-full backdrop-blur-3xl'></div>
            <div className="relative max-w-6xl mx-auto">
                {/* Event Info Section */}
                <div className="text-white space-y-6 mt-[10vh] mb-4">
                    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 flex flex-col justify-center items-center">
                        <div className="inline-block bg-white text-gray-800 px-2 py-1 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-1 fonseca">
                            TEENS VIRTUAL
                        </div>
                        <h1 className="text-4xl md:text-6xl text-center font-black mb-0 leading-tight fonseca-bold">
                            BOOT CAMP
                        </h1>
                        <p className="text-sm md:text-xl italic font-light mb-0 fonseca">with ETSO</p>
                    </div>
                </div>

                {/* <AdminStystem /> */}

                <div className="grid lg:grid-cols-2 gap-8 items-center">
                    {/* Registration Success Message */}
                    {(!isSubmitted2 && isSubmitted) && <div className="bg-white/10 h-full rounded-3xl shadow-2xl p-8 text-center">
                        <div className="bg-white w-full rounded-3xl shadow-2xl p-8 text-center">
                            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800 mb-4">Registration Successful!</h2>
                            <p className="text-gray-600 mb-6">
                                Welcome to the TSO Ministries Teens Virtual Boot Camp, {form.surname} {form.first_name}!
                                Check your email for event details and Zoom link and Whatsapp Group Link.
                            </p>
                            {/* <button
                        onClick={() => setIsSubmitted(false)}
                        className="bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-full transition-colors"
                    >
                        Register Another Person
                    </button> */}
                        </div>
                    </div>}

                    {!isSubmitted && isSubmitted2 && <div className="bg-white/10 h-full rounded-3xl shadow-2xl p-8 text-center">
                        <div className="bg-white w-full rounded-3xl shadow-2xl p-8 text-center">
                            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800 mb-4">WhatsApp Number Added!</h2>
                            <p className="text-gray-600 mb-6">
                                Your WhatsApp number has been successfully added. 
                            </p>
                            {/* <button
                        onClick={() => setIsSubmitted(false)}
                        className="bg-red-500 hover:bg-red-600 text-white font-bold py-3 px-6 rounded-full transition-colors"
                    >
                        Register Another Person
                    </button> */}
                        </div>
                    </div>}

                    {/* Registration Form */}
                    {(!isSubmitted && !isSubmitted2) && <div className="bg-white h-full rounded-3xl shadow-2xl p-8">
                        <div className="text-center mb-8">
                            <Users className="w-12 h-12 text-red-500 mx-auto mb-4" />
                            <h2 className="text-3xl font-bold text-gray-800 mb-2">Join the Boot Camp</h2>
                            <p className="text-gray-600">Register now to secure your spot in this transformative virtual experience</p>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="first_name" className="block text-sm font-semibold text-gray-700 mb-2">
                                    First Name
                                </label>
                                <div className="relative">
                                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                    <input
                                        type="text"
                                        name="first_name"
                                        value={form.first_name}
                                        onChange={handleChange}
                                        required
                                        className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:border-red-500 focus:outline-none transition-colors text-gray-800 placeholder-gray-400"
                                        placeholder="Enter your First name"
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="surname" className="block text-sm font-semibold text-gray-700 mb-2">
                                    Last Name
                                </label>
                                <div className="relative">
                                    <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                    <input
                                        type="text"
                                        name="surname"
                                        value={form.surname}
                                        onChange={handleChange}
                                        required
                                        className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:border-red-500 focus:outline-none transition-colors text-gray-800 placeholder-gray-400"
                                        placeholder="Enter your Last name"
                                    />
                                </div>
                            </div>


                            <div>
                                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                    Phone Number
                                </label>
                                <VTCPhoneInput
                                    value={form.phone_number}
                                    onChange={handleChange}
                                    setForm={setForm}
                                />
                            </div>

                            <div>
                                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                    Email Address
                                </label>
                                <VTCEmailInput
                                    value={form.email_address}
                                    onChange={handleChange}
                                    setForm={setForm}
                                />
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-bold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
                            >
                                Register for Boot Camp
                            </button>
                        </form>

                        <div className="mt-6 text-center text-sm text-gray-500">
                            <p>By registering, you'll receive the Zoom link and event materials via email.</p>
                        </div>

                        {/* Loading Modal */}
                        <motion.div
                            key={isSubmitting}
                            initial={{ opacity: 0, display: "none" }}
                            animate={isSubmitting === true ? { opacity: 1, display: "flex" } : { opacity: 0, display: "none" }}
                            // whileInView={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, display: "none" }}
                            transition={{ duration: 0.6, ease: easeInOut }}
                            className='absolute h-full w-full bg-black/40 top-0 left-0 rounded-2xl flex flex-col justify-center items-center'
                        >
                            <motion.div
                                initial={{ scale: 1 }}
                                animate={{ scale: 1.5 }}
                                transition={{
                                    duration: 0.6,
                                    ease: easeInOut,
                                    repeat: Infinity,
                                    repeatType: "reverse",
                                }}
                            >
                                <ActivityIcon size={32} />
                            </motion.div>
                        </motion.div>
                    </div>}


                    <div className='h-full'>
                        <div className='p-5 w-full rounded-3xl mb-2 bg-white/10 text-white'>
                            <p className='text-2xl font-bold'>Additional Steps</p>
                            <p className='text-sm mb-4'>Tap the button below to add your WhatsApp number (if you haven’t already).</p>
                            <div className='flex gap-4'>
                                <div
                                    className='flex flex-col items-center justify-center bg-amber-600 rounded-2xl p-4 px-5 cursor-pointer hover:bg-amber-700 transition-colors'
                                    onClick={() => setShowWhatsappModal(true)}
                                >
                                    <p className='font-bold flex items-center justify-center gap-2'>
                                        <Phone size={18} /> Add Whatsapp Number
                                    </p>
                                </div>
                                <div 
                                className='flex items-center justify-center bg-green-700 rounded-2xl p-4 px-5 cursor-pointer hover:bg-green-800 transition-colors'
                                onClick={() => {window.open("https://chat.whatsapp.com/Feb4hNZXCm47ssNSHepvng?mode=ac_t", "_blank")}}
                                >
                                    <p className='font-bold flex items-center justify-cente gap-2'>
                                        <MessageCircle size={18} /> Join Whatsapp Group
                                        </p>
                                </div>
                            </div>
                        </div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.8 }}
                            className="relative aspect-[4/4] md:aspect-[4/5] md:block flex justify-center items-center bg-black overflow-hidden rounded-3xl mb-8 md:mb-0"
                        >
                            <img
                                src={"https://tsoministries.com/wp-content/uploads/2025/08/BOOT_CAMP.png"}
                                alt="Healing Party"
                                className="relative w-full h-full object-cover"
                            />
                        </motion.div>
                    </div>
                </div>

                {/* Event Info Section */}
                <div className="text-white space-y-6 my-6 mb-4">
                    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 grid lg:grid-cols-2 gap-8 items-center font-sans">
                        <div className="bg-blue-800/60 rounded-xl p-4">
                            <h3 className="text-white font-bold text-lg mb-1">TOPICS</h3>
                            <div className="text-sm space-y-2">
                                <div>1. Who is God? and what is this Gospel?</div>
                                <div>2. Holy Spirit and Me.</div>
                                <div>3. HS-esteem: Defining my esteem through the lens of the holyspirit.</div>
                                <div>4. Finding your faith feels: understanding purpose.</div>
                                <div className="mt-3 text-xs">
                                    <div className="font-semibold mb-1">Question and answers on:</div>
                                    <div>• how to deal with parents,</div>
                                    <div>• sexual orientation</div>
                                    <div>• Relationship and any other question you want ETSO to answer.</div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-red-800/60 rounded-xl p-4 h-full">
                            <h3 className="text-white font-bold text-lg mb-1 flex items-center gap-2">
                                {/* <Calendar className="w-5 h-5" /> */}
                                DETAILS
                            </h3>
                            <div className="space-y-2 text-sm">
                                <div className="flex items-center gap-1">
                                    <MapPin className="w-3 h-3 text-yellow-100" />
                                    <span>Zoom Virtual Event</span>
                                </div>
                                <div className="flex items-center gap-1">
                                    <Clock className="w-3 h-3 text-yellow-100" />
                                    <span>Time: 1pm-4pm</span>
                                </div>
                                <div className="text-xs mt-3 space-y-1 bg-white/20 p-2 pb-4 rounded-md">
                                    <div>Tuesday, 5th August</div>
                                    <div>Thursday, 7th August</div>
                                    <div>Friday, 8th August</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {showWhatsappModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white p-6 rounded-xl shadow-xl w-full max-w-md relative">
                        <h3 className="text-xl font-bold mb-4 text-center">Enter Your WhatsApp Number</h3>
                        <p className="text-sm text-gray-600 mb-4 text-center">We'll use this number to send important reminders.</p>

                        <div>
                            <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                Email Address
                            </label>
                            {/* <VTCEmailInput
                                value={form.email_address}
                                onChange={handleChange}
                                setForm={setForm}
                            /> */}
                            <input
                                type="text"
                                name="email_address"
                                value={form.email_address}
                                onChange={handleChange}
                                required
                                className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:border-red-500 focus:outline-none transition-colors text-gray-800 placeholder-gray-400"
                                placeholder="Enter your Email Address"
                            />
                            {errors.email_address && (
                                <motion.div
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    className="flex items-center mt-2 mb-2 text-red-600 text-sm"
                                >
                                    <AlertCircle className="w-4 h-4 mr-1" />
                                    {errors.email_address}
                                </motion.div>
                            )}
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                                Phone Number
                            </label>
                            <VTCPhoneInput
                                value={form.phone_number}
                                onChange={handleChange}
                                setForm={setForm}
                            />
                            {errors.phone_number && (
                                <motion.div
                                    initial={{ opacity: 0, y: -10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    className="flex items-center mt-0 text-red-600 text-sm"
                                >
                                    <AlertCircle className="w-4 h-4 mr-1" />
                                    {errors.phone_number}
                                </motion.div>
                            )}

                        </div>
                        <div className="flex justify-end mt-6 gap-4">
                            <button
                                onClick={() => setShowWhatsappModal(false)}
                                className="text-gray-600 hover:text-gray-800"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={(e) => {
                                    handle_addWhatsappNumber(e);
                                }}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                            >
                                Save Number
                            </button>
                        </div>
                        <motion.div
                            key={isSubmitting}
                            initial={{ opacity: 0, display: "none" }}
                            animate={isSubmitting === true ? { opacity: 1, display: "flex" } : { opacity: 0, display: "none" }}
                            // whileInView={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, display: "none" }}
                            transition={{ duration: 0.6, ease: easeInOut }}
                            className='absolute h-full w-full bg-black/40 top-0 left-0 rounded-2xl flex flex-col justify-center items-center'
                        >
                            <motion.div
                                initial={{ scale: 1 }}
                                animate={{ scale: 1.5 }}
                                transition={{
                                    duration: 0.6,
                                    ease: easeInOut,
                                    repeat: Infinity,
                                    repeatType: "reverse",
                                }}
                            >
                                <ActivityIcon size={32} />
                            </motion.div>
                        </motion.div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default BootCamp;













// ---------------------------
// VTCPhoneInput component
// ---------------------------
const VTCPhoneInput = ({ value, onChange, setForm }) => {
    const [phone, setPhone] = useState(value || "");
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        if (!phone) {
            setIsValid(true);
            setForm((prev) => ({ ...prev, isPhoneValid: false }));
            return;
        }

        const valid = isValidPhoneNumber(phone);
        setIsValid(valid);

        setForm((prev) => ({ ...prev, isPhoneValid: valid }));
    }, [phone, setForm]);

    const handleChange = (value) => {
        setPhone(value);
        onChange({ target: { name: "phone_number", value } });
    };

    return (
        <div className="mb-6">
            {/* <label className="block text-sm font-medium mb-2">Phone Number</label> */}
            <div className="relative">
                <PhoneInput
                    international
                    defaultCountry="NG" // Nigeria by default
                    value={phone}
                    onChange={handleChange}
                    className="w-full pl-5 border-2 py-2 bg-white/5 rounded-lg border-gray-200 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
                />
                {phone && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isValid ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : (
                            <XCircle className="text-red-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {!isValid && phone?.length > 0 && (
                <p className="text-red-500 text-sm mt-1">
                    Invalid phone number, make sure your number is in the correct format +234 809 999 9999
                </p>
            )}
        </div>
    );
};


// ---------------------------
// VTCEmailInput component
// ---------------------------
const VTCEmailInput = ({ value, onChange, setForm }) => {
    const [email, setEmail] = useState(value || "");
    const [isValid, setIsValid] = useState(true);
    const [isAvailable, setIsAvailable] = useState(null);
    const [showEmailWarning, setShowEmailWarning] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!email) {
            setIsValid(true);
            setIsAvailable(null);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(email);
        setIsValid(isEmailValid);
        setShowEmailWarning(true);

        if (!isEmailValid) {
            setIsAvailable(null);
            return;
        }

        const delay = setTimeout(async () => {
            setLoading(true);
            try {
                const available = await checkEmailAvailability(email);
                setIsAvailable(available);
            } catch (error) {
                console.error("Error checking email availability:", error);
                setIsAvailable(null); // Force null on any error
            } finally {
                setLoading(false);
            }
        }, 500);

        return () => clearTimeout(delay);
    }, [email]);

    // Always update parent form with current email availability
    useEffect(() => {
        if (!email) {
            setForm(prev => ({ ...prev, isEmailAvailable: null }));
            return;
        }

        if (isValid) {
            setForm(prev => ({ ...prev, isEmailAvailable: isAvailable }));
        } else {
            setForm(prev => ({ ...prev, isEmailAvailable: false }));
        }
    }, [email, isValid, isAvailable, setForm]);

    const handleChange = (e) => {
        setEmail(e.target.value);
        onChange({ target: { name: "email_address", value: e.target.value } });
    };

    return (
        <div className="mb-6">
            {/* <label className="block text-sm font-medium mb-2">Email Address</label> */}
            <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                    type="email"
                    name="email_address"
                    value={email}
                    onChange={handleChange}
                    className="w-full pl-12 pr-4 py-4 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent transition-all duration-300"
                    required
                />
                {loading ? (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        Checking...
                    </div>
                ) : showEmailWarning && isValid && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isAvailable === true ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : isAvailable === false ? (
                            <XCircle className="text-red-500 w-5 h-5" />
                        ) : email.length >= 1 && (
                            <AlertCircle className="text-yellow-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {showEmailWarning && !isValid && email.length > 0 && (
                <p className="text-red-500 text-sm mt-1">Invalid email format.</p>
            )}

            {showEmailWarning && isValid && isAvailable === false && (
                <p className="text-red-500 text-sm mt-1">
                    This email is already in use. You are registered already.
                </p>
            )}

            {email.length >= 1 && showEmailWarning && isValid && isAvailable === null && !loading && (
                <p className="text-yellow-500 text-sm mt-1">
                    Unable to verify email. Please check your internet connection.
                </p>
            )}
        </div>
    );
};

// -----------------------------------------
// checkEmailAvailability (utility function)
// -----------------------------------------
async function checkEmailAvailability(email) {
    const endpoint = 'https://tsoministries.com/wp-json/wp/v2/vtc';
    let page = 1;
    let emailExists = false;

    try {
        while (true) {
            const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address`);

            if (!response.ok) {
                // If 400 and page > 1, assume we've reached the end
                if (response.status === 400 && page > 1) {
                    break;
                }
                throw new Error(`Error fetching page ${page}`);
            }

            const data = await response.json();

            if (!Array.isArray(data) || data.length === 0) {
                break;
            }

            for (const item of data) {
                if (item.email_address && item.email_address.toLowerCase() === email.toLowerCase()) {
                    emailExists = true;
                    break;
                }
            }

            if (emailExists || data.length < 100) {
                break;
            }

            page++;
        }

        return !emailExists; // true = available
    } catch (error) {
        console.error('Failed to check email v2:', error);
        return null;
    }
}